
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/install",
      function () {
        return require("private-next-pages/install.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/install"])
      });
    }
  